import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Switch, Route } from 'react-router-dom'

// Components
import AdminPromotionsFormEdit from './AdminPromotionsFormEdit'

// State
import { addRoute } from '../../../store/actions/route'
import { setpageTitle } from '../../../store/actions/siteInfo'

class AdminPromotions extends Component {
    constructor(props) {
        super(props)

        this.props.addRoute(this.props.match)
        this.props.setpageTitle('Promotions')
    }

    // ===================================================================================
    //  RENDER
    // ===================================================================================
    render() {
        return (
            <Switch>
                <Route path={'/admin/promotions/:id?'} component={AdminPromotionsFormEdit} />
            </Switch>
        )
    }
}

export default connect(null, { addRoute, setpageTitle })(AdminPromotions)



// WEBPACK FOOTER //
// ./src/components/admin/promotions/AdminPromotions.js